import { map } from 'rxjs/operators/map';
import { OPERATOR_CHANGED, OPERATOR_EQUALS, OPERATOR_GT, OPERATOR_GT_EQUALS, OPERATOR_IN, OPERATOR_IS, OPERATOR_IS_NOT, OPERATOR_LIKE, OPERATOR_LT, OPERATOR_LT_EQUALS, OPERATOR_NOT_EQUALS, OPERATOR_NOT_IN, OPERATOR_NOT_LIKE, OPERATOR_WAS, OPERATOR_WAS_IN, OPERATOR_WAS_NOT, OPERATOR_WAS_NOT_IN } from '@atlaskit/jql-ast';
// Opinionated order in which we want to render operators
export var ORDERED_OPERATORS = [OPERATOR_EQUALS, OPERATOR_NOT_EQUALS, OPERATOR_LIKE, OPERATOR_NOT_LIKE, OPERATOR_LT_EQUALS, OPERATOR_GT_EQUALS, OPERATOR_GT, OPERATOR_LT, OPERATOR_IS, OPERATOR_IS_NOT, OPERATOR_IN, OPERATOR_NOT_IN, OPERATOR_WAS, OPERATOR_WAS_NOT, OPERATOR_WAS_IN, OPERATOR_WAS_NOT_IN, OPERATOR_CHANGED];
export var sortOperators = function sortOperators(operators$) {
  return operators$.pipe(map(function (options) {
    return ORDERED_OPERATORS.reduce(function (result, orderedOperator) {
      var matchingOption = options.find(function (option) {
        return orderedOperator.toLowerCase() === option.value.toLowerCase();
      });
      if (matchingOption !== undefined) {
        result.push(matchingOption);
      }
      return result;
    }, []);
  }));
};